// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__kOOEB","info":"Note_info__25un7","note":"Note_note__1pUXz","actions":"Note_actions__3kamG"};